"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_SUBMISSION_UPDATE_QA_RESULT_MUTATION = exports.AdminSubmissionUpdateQaResultInputGql = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.AdminSubmissionUpdateQaResultInputGql = (0, graphql_tag_1.default) `
  input AdminSubmissionUpdateQaResultInput {
    id: String!
    gameBuildId: String!
    qaResult: QAResultInput!
  }
`;
exports.ADMIN_SUBMISSION_UPDATE_QA_RESULT_MUTATION = (0, graphql_tag_1.default) `
  mutation adminSubmissionUpdateQaResult($input: AdminSubmissionUpdateQaResultInput!) {
    adminSubmissionUpdateQaResult(input: $input) {
      id
    }
  }
`;
